import http from '@/utils/http';

// 获取
export const getDelegationList = (params) => {
    return http.request({
        url: "/v1/olympics/delegation/list",
        method: 'get',
        params: params,
    })
}

// 更新
export const updateDelegation = (params) => {
    return http.request({
        url: "/v1/olympics/delegation/update",
        method: 'post',
        data: params,
    })
}

// 搜索
export const searchDelegation = (params) => {
    return http.request({
        url: "/v1/olympics/delegation/search",
        method: 'post',
        data: params,
    })
}
